import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
// import { environment } from '../../../../environments/environment';

import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';

@Injectable({
  providedIn: 'root'
})
export class InventoryHttpService {

    apiName: string;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.apiName = this.configService.get('host');
    }

	getMachineInventory(queryParams: any): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_mac_inventory';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
			//   console.log(response);
			  observer.next(response.data || response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getMachineLocInventory(queryParams: any): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_mac_loc_inventory';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
			//   console.log(response);
			  observer.next(response.data || response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getCampusInventory(queryParams: any): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_campus_inventory';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
			//   console.log(response);
			  observer.next(response.data || response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	updateMacInv(queryParams: any): Promise<any> {
		return new Promise((resolve, reject) => {
			const path = '/dashboard/update_mac_inventory';
			const params = {
				body: queryParams
			};
			API.put(this.apiName, path, params).then(resp => {
				resolve(resp.data);
			}).catch(err => {
				console.log(err.response);
				reject(err);
			});
		});
	}

	updateMacLocInv(queryParams: any): Promise<any> {
		return new Promise((resolve, reject) => {
			const path = '/dashboard/update_mac_loc_inventory';
			const params = {
				body: queryParams
			};
			API.put(this.apiName, path, params).then(resp => {
				resolve(resp.data);
			}).catch(err => {
				console.log(err.response);
				reject(err);
			});
		});
	}

	updateCampusInventory(queryParams: any): Promise<any> {
		return new Promise((resolve, reject) => {
			const path = '/dashboard/update_campus_inventory';
			const params = {
				body: queryParams
			};
			API.put(this.apiName, path, params).then(resp => {
				resolve(resp.data);
			}).catch(err => {
				console.log(err.response);
				reject(err);
			});
		});
	}

}
